import { memo } from "react";

import { RadioGroup, RadioGroupItem } from "@/components/ui/input/radio-group";

import { FormErrorMessage, FormItem, FormLabel } from "../../../_base/form";

import type { FormOptionType } from "../../../_types/type";

type RadioGroupFieldProps = {
	value: string;
	options: FormOptionType[];
	handleValueChange: (value: string) => void;

	errorMessage?: string;
	label?: string;
};

export const RadioGroupField = memo(
	({ value, options, handleValueChange, label, errorMessage }: RadioGroupFieldProps): JSX.Element | null => {
		return (
			<FormItem>
				<FormLabel>{label}</FormLabel>

				<RadioGroup onValueChange={handleValueChange} defaultValue={value}>
					{options.map(({ id, label, value }) => {
						if (!String(value)) return null;

						return (
							<div key={id} className="flex items-center space-x-3 space-y-0">
								<RadioGroupItem value={String(value)} id={id} />
								<label htmlFor={id} className="pb-0.5">
									{String(label)}
								</label>
							</div>
						);
					})}
				</RadioGroup>
				<FormErrorMessage>{errorMessage}</FormErrorMessage>
			</FormItem>
		);
	},
);
